import { Component } from 'react';
import _ from 'lodash';
import { extensionLandingPageQuery } from '@queries/pages/extension';
import { withServerSideProps } from '@lib/withServerSideProps';
import Page from '@ui/components/ams/Pages/Page';
import AMS from '@ui/components/ams';
import { pushPageViewEvent } from '@lib/atm';

const PAGE_NAME = 'airmilesshops-assistant';

class Extension extends Component {
  componentDidMount() {
    const {
      userSessionData: {
        userData,
      },
      locale,
    } = this.props;

    pushPageViewEvent(
      window,
      userData,
      {
        locale,
        sections: [PAGE_NAME],
        pageCategory: 'page',
      },
    );
  }

  render() {
    const {
      globalPageData,
      pageData,
      userSessionData,
      requestData,
      locale,
      client,
    } = this.props;

    const { extensionInstallation } = pageData;

    const {
      metaDescription,
      pageTitle,
    } = extensionInstallation;

    return (
      <Page
        analyticsPageName={PAGE_NAME}
        pageTitle={pageTitle}
        metaDescription={metaDescription}
        globalPageData={globalPageData}
        requestData={requestData}
        userSessionData={userSessionData}
      >
        <AMS.ExtensionLanding
          locale={locale}
          pageData={extensionInstallation}
          client={client}
        />
      </Page>
    );
  }
}

export const getServerSideProps = withServerSideProps({
  pageQuery: extensionLandingPageQuery,
  getAdditionalPageProps: (ctx) => ({
    client: _.get(ctx?.req?.device ?? {}, 'client.normalized_family'),
  })
});

export default Extension;
